import Logger from '../logger';

const onOpenHandler = (code) => {
    // document.dispatchEvent(new CustomEvent('WCCloserInitialized'));
    Logger.log('onOpenHandler');
    if (!code) {
        window.WC._localStorage.set('userStatus', 'annonymous');
    }
    window.WC._localStorage.set('CloserState', 'opened');
};

export { onOpenHandler };
